<template>
  <nav class="navigationTop">
    <swiper
      v-if="categoryList.length"
      :options="swiperNavigationOption"
      ref="navigationTopSwiper"
    >
      <swiper-slide>
        <router-link to="/main" :idx="0">홈</router-link>
      </swiper-slide>
      <swiper-slide v-for="(category, index) in categoryList" :key="index">
        <router-link :to="`/category/${category.categoryId}`" :idx="index + 1">
          {{ category.categoryName }}
        </router-link>
      </swiper-slide>
    </swiper>
  </nav>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
import { isMobile } from '@/utils'

export default {
  name: 'NavigationTop',
  components: {
    swiper,
    swiperSlide
  },
  watch: {
    '$route.path': {
      handler(n, o) {
        if (n) {
          this.$nextTick(this.findActiveMenu)
        }
      }
    }
  },
  data() {
    return {
      isMobile,
      swiperNavigationOption: {
        slidesPerView: 'auto',
        freeMode: true,
        centerInsufficientSlides: true
      }
    }
  },
  methods: {
    handleOrient() {
      if (isMobile) {
        setTimeout(() => {
          this.$refs.navigationTopSwiper.update()
        }, 500)
      }
    },
    findActiveMenu() {
      const activeMenu = document.querySelector(
        '.navigationTop a.router-link-exact-active'
      )
      if (activeMenu) {
        this.swiper.slideTo(Number(activeMenu.getAttribute('idx')), 0, false)
      }
    }
  },
  computed: {
    ...mapGetters('main', ['categoryList']),
    swiper() {
      return this.$refs.navigationTopSwiper.swiper
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleOrient)
    this.findActiveMenu()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleOrient)
  }
}
</script>

<style lang="scss">
.navigationTop {
  position: fixed;
  top: 54px;
  left: 0;
  width: 100%;
  height: 45px;
  padding-top: 1px;
  // padding-right: 0; safeArea
  // padding-left: 0; safeArea
  background-color: #fff;
  border-bottom: 1px solid #c8cbdc;
  z-index: 100;
  .swiper-slide {
    width: auto;
  }
  a {
    display: inline-block;
    min-width: 75px;
    height: 44px;
    padding: 16px 15px 0;
    text-align: center;
    color: #3e4356;
  }
  .active {
    position: relative;
    color: #6134f1;
    font-weight: bold;
    border-bottom: 3px solid #6134f1;
  }
}

@media screen and (min-width: 1024px) {
  .navigationTop {
    width: 1024px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
